import { render, staticRenderFns } from "./HolidayBoxModal.vue?vue&type=template&id=0755d0e5&scoped=true&"
import script from "./HolidayBoxModal.vue?vue&type=script&lang=js&"
export * from "./HolidayBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./HolidayBoxModal.vue?vue&type=style&index=0&id=0755d0e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755d0e5",
  null
  
)

export default component.exports